import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { ProjectSchedulesService } from "@/modules/projects/service/projectSchedule";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const useGetSchedulesContractorVisitQuery = (
  projectId: string,
  scheduleId: string,
  visitId: string,
) => {
  const name = "schedulesDayContractorVisit";
  const options = useCreateDataTableOptions(name);
  const queryKey = useDynamicQueryParams(name, options, {
    projectId,
    scheduleId,
    visitId,
  });

  const query = useQuery({
    queryKey,
    queryFn: () =>
      ProjectSchedulesService.getContractorVisit(
        projectId,
        scheduleId,
        visitId,
      ),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return query;
};
